import { useMutation } from "react-query";
import { changeSlidesOrder } from "../services/SlideShowsApi";

const useChangeSlideOrder = (newOrder) => {
  return useMutation(changeSlidesOrder);
};

export default useChangeSlideOrder;
